import { isFunction, uuidv4 } from "./Utils";

export const states = {
  IDLE: "idle",
  PROCESSING: "processing",
  ERROR: "error",
  SUCCESS: "success"
};

const Queue = (() => {
  let _tasks = [];
  const state = states.IDLE;

  let _onDoneCallback = () => {};
  let _onEnqueueCallback = () => {};

  const queue = (task) => {
    if (!task) return;

    // Assign Task Id
    const _task = { ...task, id: uuidv4() };

    console.log("Queing task", _task.id);

    _tasks.push(_task);
  };
  const enqueue = () => {
    const task = _tasks.shift();

    console.log("Enqueing task", task.id);
    _onEnqueueCallback(task);
  };

  const isEmpty = () => {
    return _tasks.length === 0;
  };

  const getItems = () => {
    return _tasks;
  };

  const getLength = () => {
    return _tasks.length;
  };

  const clear = () => {
    _tasks = [];
  };

  const flush = () => {
    // Sync
    while (!isEmpty()) {
      enqueue();
    }

    _onDoneCallback();
  };

  const process = (fn) => {
    flush();
  };

  return Object.freeze({
    queue,
    enqueue,
    clear,
    flush,
    process,
    isEmpty,
    getItems,
    getLength,
    getState: () => {
      return state;
    },
    onDone: (fn) => {
      // Do Something
      if (isFunction(fn)) {
        _onDoneCallback = fn;
      }
    },
    onEnqueue: (fn) => {
      if (isFunction(fn)) {
        _onEnqueueCallback = fn;
      }
    }
  });
})();

export default Queue;
